export class ServicosFactory {
  constructor(instance) {
    this.instance = instance;
  }

  listServicos(filter) {
    const filtredParams = filter ? { ...filter } : {};

    if (filtredParams) delete filtredParams.initial;

    return this.instance.get('/v1/servicos', {
      params: filtredParams,
    });
  }

  showServico(id, filter) {
    return this.instance.get(`/v1/servicos/${id}`, {
      params: filter || null,
    });
  }

  insertServico(data) {
    return this.instance.post('/v1/servicos', data);
  }

  updateServico(id, data) {
    return this.instance.put(`/v1/servicos/${id}`, data);
  }

  removeServico(id) {
    return this.instance.delete(`/v1/servicos/${id}`);
  }
}

export default ServicosFactory;
